import { environment } from '../../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
export class ApolloService {
    constructor(apollo) {
        this.apollo = apollo;
    }
    query(options) {
        return this.apollo.use(environment.apolloNameSpace).query(options);
    }
}
ApolloService.ɵfac = function ApolloService_Factory(t) { return new (t || ApolloService)(i0.ɵɵinject(i1.Apollo)); };
ApolloService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApolloService, factory: ApolloService.ɵfac, providedIn: 'root' });
